var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    group = _require$doc$builders.group,
    indent = _require$doc$builders.indent,
    line = _require$doc$builders.line,
    softline = _require$doc$builders.softline;

var printBody = function printBody(node, path, print) {
  if (node.body.type === 'Block') {
    return concat([' ', path.call(print, 'body')]);
  }

  return group(indent(concat([line, path.call(print, 'body')])));
};

var WhileStatement = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    return concat([group(concat(['while (', indent(concat([softline, path.call(_print, 'condition')])), softline, ')'])), printBody(node, path, _print)]);
  }
};
module.exports = WhileStatement;